import Vue from 'vue'
import VueRouter from 'vue-router'
import JobList from '../views/JobList.vue'
import JobDetails from '../views/JobDetails.vue'
import JobAlerts from '../views/JobAlerts.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'job-list',
    component: JobList
  },
  {
    path: '/job-alert',
    name: 'job-alerts',
    component: JobAlerts
  },
  {
    path: '/:slug',
    name: 'job-details',
    component: JobDetails
  },
]

const router = new VueRouter({
  routes
})

export default router
